import { IParameter } from '@/modules/gpt-chats/types/tools.service.type';

export const getValue = (obj: any, path: (string | number)[]) => {
  return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};

export const setValue = (obj: any, path: (string | number)[], value: any): any => {
  if (path.length === 0) return value;
  const [head, ...tail] = path;

  if (Array.isArray(obj)) {
    const newArr = [...obj];
    newArr[Number(head)] = setValue(obj[Number(head)], tail, value);
    return newArr;
  }

  return {
    ...obj,
    [head]: setValue(obj ? obj[head] : undefined, tail, value),
  };
};

export const getInitialValue = (param: IParameter): any => {
  if (
    param.DefaultValue !== undefined &&
    param.DefaultValue !== '' &&
    param.DefaultValue !== null &&
    param.DefaultValue !== 'null'
  )
    return param.DefaultValue;

  const type = param.Type?.toLowerCase();

  if (type === 'object') {
    const obj: Record<string, any> = {};
    if (param.Properties) {
      Object.entries(param.Properties).forEach(([key, p]) => {
        obj[key] = getInitialValue(p);
      });
    }
    return obj;
  }
  if (type === 'array') return [];
  if (type === 'boolean') return false;
  if (type === 'number' || type === 'integer') return 0;
  if (type === 'variable') return param.DefaultValue || '';
  return '';
};

export const generateInitialData = (schema: Record<string, IParameter>) => {
  const data: Record<string, any> = {};
  Object.entries(schema).forEach(([key, param]) => {
    data[key] = getInitialValue(param);
  });
  return data;
};
